import type { MouseEvent } from 'react';

import { AModal } from 'components/shared/AModal';
import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';
import { useModalClose } from 'hooks/useModalClose';

import cs from '../index.module.css';
// @ts-expect-error // TOFIX: Webm is not recognized by TS
import webm from './lookbook-content-missing.webm';

export function LookbookContentMissingWarningModal({
  onClose,
  onSave,
}: {
  onClose: () => void;
  onSave: (...args: any) => Promise<void>;
}) {
  useModalClose();

  const handleSave = async (e: MouseEvent<HTMLElement>) => {
    await onSave(e);
    onClose();
  };

  return (
    <AModal
      isOpen
      size="xs"
      onClose={onClose}
      header="Heads Up!"
      contentClassName={cs.modalContent}
      footer={
        <>
          <Button type="default" size="medium" onClick={handleSave}>
            Ignore & Continue
          </Button>
          <Button size="medium" onClick={onClose}>
            Add Content
          </Button>
        </>
      }
    >
      <div className={cs.description}>
        <Text type="accent" size="default">
          It seems you have not pulled any content into this Lookbook. Please search your Content Library to pull in any
          relevant content.
        </Text>
        <video className={cs.hintGif} controls={false} autoPlay loop>
          <source src={webm} type="video/webm" />
        </video>
      </div>
    </AModal>
  );
}
